module.exports = __webpack_public_path__ + "static/media/C024.eecc0ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C024.jpg
// module id = 307
// module chunks = 0